<template>
  <!-- 清单视图 -->
  <div class="window" style="width: 100%">
    <div class="nav">
      <div class="nav-lt">
        <img
          class="nav-lt-img"
          src="../../assets/img/home/center/whole.png"
          alt=""
          @click="displayleft"
        />
        <div class="nav-lt-tit">清单视图</div>
      </div>
      <div class="nav-rt">
        <el-switch
          class="nav-rt-sw"
          v-model="switchVal"
          :width="33"
          active-color="#13ce66"
          inactive-color="#bbbbbc"
          @change="switchChang"
        >
        </el-switch>
        <div class="nav-rt-txt">显示已完成</div>
      </div>
    </div>

    <div class="main" ref="viewBox">
      <div class="main-box" v-for="(item, index) in scollNavData" :key="index">
        <div class="main-box-tp" @click="listaAppearClick(item)">
          <div class="main-box-tp-lt">
            <img
              class="main-box-tp-lt-img"
              src="../../assets/img/home/center/uncomplete.png"
              alt=""
            />
            <div
              class="main-box-tp-lt-txt"
              :style="{ color: randomColor[index] }"
            >
              {{ item.todo_category_name }}（{{ item.info.length }}）
            </div>
          </div>
        </div>

        <div class="main-box-bt">
          <input
            type="text"
            placeholder="添加任务"
            v-model="item.todo_input"
            @keyup.enter="foursubmit(item.todo_category_id, index)"
          />
          <div
            class="main-box-bt-cont"
            v-for="(item1, index1) in item.info"
            :key="index1"
            v-show="
              switchVal
                ? !item1.task_status || item1.task_status
                : !item1.task_status
            "
          >
            <div>
              <img
                @click="chooseCheak(item1)"
                class="main-box-bt-cont-img"
                v-show="!item1.task_status"
                src="../../assets/img/home/center/uncomplete.png"
                alt=""
              />
              <img
                class="main-box-bt-cont-img"
                v-show="item1.task_status"
                src="../../assets/img/home/center/complete.png"
                alt=""
              />
            </div>
            <div
              class="main-box-bt-cont-txt"
              :style="{ opacity: !item1.task_status ? '' : '.5' }"
            >
              {{ item1.task_name }}
            </div>
          </div>
          <!-- <img
              class="main-box-bt-img"
              v-show="item.itemData.length == 0"
              src="../../assets/img/list/zw.png"
              alt=""
            /> -->
        </div>
      </div>
    </div>
    <el-slider
      class="slider"
      v-model="scrollVal"
      :show-tooltip="false"
      :format-tooltip="formatTooltip"
    ></el-slider>
     <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
</template>

<script>
import bus from "./../../util/bus";
import leftNav from "../../components/content/leftNav";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      scrollVal: 0,
      switchVal: false,
      randomColor: [],
      addfour: "",
      scollNavData: [],
      drawer: false,
    };
  },
  created() {
    this.qblist();
  },

  methods: {
     //左边显示
    displayleft() {
      if(document.body.clientWidth <= 1200){
        this.drawer = true;
      }
    },
    sjcolor() {
      let random = Math.random(); //生成随机数：0.32273213103830223
      let demo = 2 << 23; //十进制数：16777216
      let list = random * demo; //生成代表颜色的随机数：5414546.672569901
      let num = Math.floor(list); //向下取整：5414546
      let rColor = "#" + num.toString(16);
      this.randomColor.push(rColor);
      // this.colorRandom = "#" + "00" + num.toString(16).slice(0, 3) + 1;
    },
    //发布
    foursubmit(id, index) {
      console.log(this.scollNavData[index].todo_input, id);
      let data = {
        task_name: this.scollNavData[index].todo_input,
        todo_from: id,
      };
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      this.$api
        .releasetodo(data, header)
        .then((res) => {
          console.log(res, "发布清单");

          //刷新左侧边栏
          bus.$emit("refreshLeft");
          this.scollNavData[index].todo_input = "";
          this.qblist();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    qblist() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .qblist("", header)
        .then((res) => {
          console.log(res, "全部自定义清单");
          this.scollNavData = res.data.result;
          // for (var i = 0; i < this.scollNavData.length; i++) {
          //   // this.sjcolor()
          //   let random = Math.random(); //生成随机数：0.32273213103830223
          //   let demo = 2 << 23; //十进制数：16777216
          //   let list = random * demo; //生成代表颜色的随机数：5414546.672569901
          //   let num = Math.floor(list); //向下取整：5414546
          //   let rColor = "#" + num.toString(16);
          //   this.randomColor.push(rColor);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listaAppearClick(item) {
      console.log(item, "kkkkkkk");
      this.$router.push({
        name: "fourlists",
        query: {
          tet: "自定义",
          from_id: item.todo_category_id,
          name: item.todo_category_name,
        },
      });
    },
    // 显示隐藏
    switchChang(e) {
      console.log(e, "点击的switch的值");
      this.switchVal = e;
    },

    // cheakbox
    chooseCheak(item) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let data = {
        todo_id: item.id,
      };
      this.$api
        .completed(data, header)
        .then((res) => {
          this.qblist();
          console.log(res, "点击已完成");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 滑块
    formatTooltip(e) {
      console.log(
        e,
        "滑块的值",
        this.$refs.viewBox.clientWidth,
        "页面可视区的宽度"
      );
      console.log(this.$refs.viewBox.scrollWidth, "viewBox的总宽度");
      this.$refs.viewBox.scrollLeft =
        (this.$refs.viewBox.scrollWidth - this.$refs.viewBox.clientWidth) *
        (e / 100);
      console.log(this.$refs.viewBox.scrollLeft, "左边的值");
    },
  },
};
</script>

<style lang="scss" scoped>
.window {
  width: 100%;
  height: 100%;
  background-color: var(--color-theme);
  border: 1rpx solid #f7f7f7;
}

.main::-webkit-scrollbar {
  display: none;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 50px;
  margin: 0 0 30px 0;

  &-lt {
    display: flex;
    align-items: center;
    &-img {
      width: 20px;
      height: 16px;
      margin: 0 35px 0 20px;
    }

    &-tit {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }
  }

  &-rt {
    display: flex;
    align-items: center;

    &-sw {
      width: 33px;
      height: 16px;
      span {
        height: 16px;
      }

      .el-switch__core {
        height: 16px !important;
      }
      .el-switch__core::after {
        height: 13px !important;
        width: 13px !important;
      }
    }

    &-txt {
      font-size: 16px;
      color: #666666;
      margin: 0 40px 0 6px;
    }
  }
}

.main {
  width: 100%;
  height: calc(100% - 180px);
  overflow-x: scroll;
  display: flex;
  scrollbar-width: none;

  &-box {
    width: 322px;
    height: 100%;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0 10px;
    padding: 20px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;

    &-tp {
      width: 282px;
      height: 40px;
      justify-content: space-between;

      &-lt {
        display: flex;
        align-items: center;
        margin-bottom: 46px;

        &-img {
          width: 20px;
          height: 17px;
          margin-right: 20px;
        }

        &-txt {
          font-size: 18px;
          color: #4b8cf1;
        }
      }

      &-rt {
        width: 17px;
        height: 17px;
        cursor: pointer;
      }
    }

    &-bt {
      width: 100%;
      text-align: center;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      input {
        width: 100%;
        height: 35px;
        border: none;
        border-radius: 8px;
        background-color: #f3f3f3;
        padding-left: 10px;
      }

      &-cont {
        display: flex;
        align-items: center;
        margin: 10px 0;

        &-img {
          width: 21px;
          height: 21px;
          margin-right: 20px;
        }

        &-txt {
          width: 100%;
          height: 35px;
          font-size: 15px;
          line-height: 35px;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
        }
      }

      &-img {
        margin-top: 30%;
        width: 150px;
        height: 115px;
      }
    }
  }
}

.slider {
  width: 300px;
  margin: 0 auto;

  ::v-deep .el-slider__runway {
    height: 14px;
    border-radius: 7px;
    background-color: #e7e7e7;

    .el-slider__bar {
      display: none;
    }

    .el-slider__button-wrapper {
      width: 100px;
      height: 14px;
      border-radius: 7px;
      top: -3px;
      .el-slider__button {
        width: 50px;
        height: 14px;
        border: none;
        border-radius: 7px;
        background-color: #d5d5d7;
      }
      .el-slider__button:hover {
        cursor: pointer;
      }
    }
  }
}
</style>  